import _import from './_import.js';
// import where_to_buy from '../views/glocalme/where_to_buy';

export default [
	// 购买渠道
	{
	  path: 'where_to_buy',
	  component: _import('glocalme/where_to_buy'),
      children: [{
	    path: ':type',
        component: _import('glocalme/where_to_buy')
      }]
	},
    {
        path: 'glocalme/where_to_buy',
        component: _import('glocalme/where_to_buy')
    }
];



// WEBPACK FOOTER //
// ./src/router/glocalme.js